import { ContactInfo } from "./OrgShippingInfoForm";
import config from "../../config";
import { CartState } from "../../contexts/Cart/CartContext";
import { CartItem } from "../../Interfaces/Types";
import { ShippingInfo } from "../../Interfaces/ShippingInfo";
import apiClient from "../../services/apiClient";
import axios from "axios";

const DONATION_ID = config.DONATION_ITEM_ID;
const BUYOUT_ID = config.BUYOUT_ITEM_ID;
const BASE_API = config.API_BASE_URL;

const fetchSquareLink = async (
  contactInfo: ContactInfo,
  cart: CartItem[],
  subtotal: number,
  shippingInfo: ShippingInfo,
  shippingCost: number,
) => {
  if (!contactInfo?.full_name || !contactInfo?.email) {
    return;
  }
  try {
    const response = await apiClient.post(
      `${BASE_API}checkout/check-taxation-info/square/`,
      {
        shippingData: shippingInfo,
        shipping: shippingCost,
        cart,
      },
    );

    return response;
  } catch (error: unknown) {
    if (axios.isAxiosError(error) && error.response?.status == 409) {
      const erroredItems = error.response.data;
      return { error: "disallowed_items", disallowedItems: erroredItems };
    }

    console.error("Error during checkout:", error);
  }
};

export default fetchSquareLink;
